/*
 * Asistente de elección de equipo — projit.es
 *
 * Cada respuesta se traduce en un filtro REAL del escaparate, y el resultado
 * se consulta en vivo contra la colección filtrada. Así no hay ninguna lista
 * de productos embebida aquí que pueda quedarse vieja, y lo que se recomienda
 * es siempre lo que hay de verdad en catálogo.
 *
 * Los filtros y sus valores los genera `generar_opciones_selector.py`
 * (`opciones-selector.js`), comprobando uno a uno que devuelven productos.
 */
(function () {
  'use strict';

  var OPC = window.OPCIONES_SELECTOR || {};
  var $ = function (id) { return document.getElementById(id); };
  var els = {
    app: $('se-app'),
    progreso: $('se-progreso'),
    pregunta: $('se-pregunta'),
    ayuda: $('se-ayuda'),
    opciones: $('se-opciones'),
    atras: $('se-atras'),
    reiniciar: $('se-reiniciar'),
    resumen: $('se-resumen'),
    resultado: $('se-resultado'),
    resTitulo: $('se-res-titulo'),
    resTexto: $('se-res-texto'),
    resCuenta: $('se-res-cuenta'),
    resProductos: $('se-res-productos'),
    resEnlace: $('se-res-enlace'),
    resAviso: $('se-res-aviso')
  };
  if (!els.app) return;

  var F = 'filter.p.m.custom.';

  // ------------------------------------------------------------------
  // El cuestionario. Cada opción lleva:
  //   filtro/valor  -> se añade a la URL de la colección filtrada
  //   handle        -> cambia de colección (cuando no hay filtro que lo
  //                    exprese, p. ej. impresora portátil)
  //   nota          -> el porqué, que es lo que convierte esto en una guía
  //                    y no en un formulario
  // Solo se usan filtros que existen de verdad; `disponible()` esconde una
  // opción si su valor no está en la colección, para no llevar a una lista
  // vacía.
  // ------------------------------------------------------------------
  var INICIO = {
    id: 'familia',
    pregunta: '¿Qué necesitas?',
    ayuda: 'Empecemos por el tipo de equipo. Si dudas entre lector y terminal: el lector solo lee, el terminal además ejecuta tu aplicación.',
    opciones: [
      { et: 'Imprimir etiquetas', familia: 'impresora',
        nota: 'Etiquetas de producto, de ubicación o de envío.' },
      { et: 'Leer códigos de barras', familia: 'lector',
        nota: 'Un lector conectado a un PC, una caja o un puesto de trabajo.' },
      { et: 'Un terminal o tablet', familia: 'terminal',
        nota: 'Un Android o Windows rugerizado que ejecuta tu ERP o tu app de almacén.' },
      { et: 'Trabajar con RFID', familia: 'rfid',
        nota: 'Leer muchas unidades a la vez sin verlas: inventario, control de paso.' }
    ]
  };

  var GUIONES = {
    impresora: {
      titulo: 'Impresora de etiquetas',
      preguntas: [
        {
          id: 'portatil',
          pregunta: '¿Dónde se va a imprimir?',
          ayuda: 'Una portátil se lleva en el cinturón y evita ir y volver al puesto; una de sobremesa o industrial vive en un sitio fijo.',
          opciones: [
            { et: 'En un puesto fijo', nota: 'Lo habitual: expedición, etiquetado en línea, oficina.' },
            { et: 'Moviéndose por el almacén', handle: 'impresora-portatiles',
              nota: 'Impresora portátil, a batería y con Bluetooth o Wi-Fi.' }
          ]
        },
        {
          id: 'tecnologia',
          pregunta: '¿Cuánto tiene que durar la etiqueta?',
          ayuda: 'Es la decisión que más condiciona el coste por etiqueta y la que más se equivoca.',
          opciones: [
            { et: 'Semanas: envío, picking, turno',
              filtro: F + 'tecnologia_impresion', valor: 'Térmica directa',
              nota: 'Térmica directa: no gasta ribbon, pero la etiqueta se oscurece con el calor y la luz en unos meses.' },
            { et: 'Meses o años: inventario, activos',
              filtro: F + 'tecnologia_impresion', valor: 'Transferencia térmica',
              nota: 'Transferencia térmica: usa ribbon y aguanta. Imprescindible si la etiqueta va a sobrevivir al almacenaje.' },
            { et: 'Las dos cosas, según el trabajo',
              filtro: F + 'tecnologia_impresion', valor: 'Térmica directa y transferencia térmica',
              nota: 'Equipos que hacen ambas: más caros, pero evitan tener dos impresoras.' }
          ]
        },
        {
          id: 'ancho',
          pregunta: '¿De qué ancho es la etiqueta?',
          ayuda: 'Si no lo sabes, mide el rollo que usas ahora. El ancho de la impresora es el máximo que admite.',
          opciones: [
            { et: 'Estrecha, hasta unos 5 cm', filtro: F + 'ancho_impresion', valor: '2"',
              nota: 'Etiqueta de producto pequeño, estantería o joyería.' },
            { et: 'Media, unos 7-8 cm', filtro: F + 'ancho_impresion', valor: '3"',
              nota: 'Un tamaño intermedio, menos común.' },
            { et: 'Estándar, unos 10 cm', filtro: F + 'ancho_impresion', valor: '4"',
              nota: 'El ancho de la etiqueta de expedición. Cubre la mayoría de los casos.' },
            { et: 'Ancha, unos 15 cm', filtro: F + 'ancho_impresion', valor: '6"',
              nota: 'Etiquetas de palé o documentación adjunta.' }
          ]
        },
        {
          id: 'resolucion',
          pregunta: '¿Qué va impreso en la etiqueta?',
          ayuda: 'Más resolución no es mejor por defecto: encarece el equipo y el ribbon, y no aporta nada si la etiqueta es sencilla.',
          opciones: [
            { et: 'Código de barras y texto normal',
              filtro: F + 'resolucion_impresion', valor: '203 dpi',
              nota: '203 dpi es el estándar del etiquetado logístico y lo que necesita la mayoría.' },
            { et: 'Letra pequeña, mucho dato o etiqueta diminuta',
              filtro: F + 'resolucion_impresion', valor: '300 dpi',
              nota: '300 dpi: hace falta en farmacia, electrónica y en cualquier etiqueta muy cargada.' }
          ]
        },
        {
          id: 'conexion',
          pregunta: '¿Cómo se va a conectar?',
          ayuda: 'Puedes saltar esta pregunta si te da igual o si el equipo va a estar junto al ordenador.',
          opcional: true,
          opciones: [
            { et: 'Por cable USB al ordenador', filtro: F + 'interfaces', valor: 'USB',
              nota: 'Lo más simple, para un solo puesto.' },
            { et: 'A la red por cable', filtro: F + 'interfaces', valor: 'Ethernet',
              nota: 'Ethernet: la comparten varios puestos y no depende de un PC encendido.' },
            { et: 'Por Wi-Fi', filtro: F + 'interfaces', valor: 'Wi-Fi',
              nota: 'Útil donde no llega cable de red.' }
          ]
        }
      ]
    },

    lector: {
      titulo: 'Lector de códigos de barras',
      preguntas: [
        {
          id: 'dimension',
          pregunta: '¿Qué códigos tienes que leer?',
          ayuda: 'Míralo en los productos que manejas: si ves cuadrados de puntos (QR, Data Matrix), necesitas 2D.',
          opciones: [
            { et: 'Solo códigos de barras de toda la vida',
              filtro: F + 'dimension_codigo', valor: '1D',
              nota: 'Un láser 1D es más barato, pero no leerá un QR ni un Data Matrix el día que aparezca.' },
            { et: 'También QR y Data Matrix',
              filtro: F + 'dimension_codigo', valor: '2D',
              nota: 'Un imager 2D lee todo, incluido lo 1D. Hoy casi todo el marcaje industrial y sanitario es 2D.' }
          ]
        },
        {
          id: 'conexion',
          pregunta: '¿El operario se mueve?',
          ayuda: 'Lo decide la distancia entre el puesto y lo que hay que leer.',
          opciones: [
            { et: 'No, lee siempre en el mismo sitio',
              filtro: F + 'tipo_conexion', valor: 'Con cable',
              nota: 'Con cable: no hay baterías que cargar ni emparejamientos que se pierdan.' },
            { et: 'Sí, se desplaza por el pasillo',
              filtro: F + 'tipo_conexion', valor: 'Inalámbrico',
              nota: 'Inalámbrico: da libertad, a cambio de gestionar la carga de la batería.' }
          ]
        },
        {
          id: 'entorno',
          pregunta: '¿Dónde se va a usar?',
          ayuda: 'El grado IP dice cuánto polvo y agua aguanta; y de paso, los modelos que lo declaran suelen ser los que soportan caídas.',
          opcional: true,
          opciones: [
            { et: 'En interior limpio: tienda, oficina, mostrador',
              filtro: F + 'proteccion_ip', valor: 'IP52',
              nota: 'Protección básica, suficiente donde el lector no se maltrata.' },
            { et: 'En almacén o industria', filtro: F + 'proteccion_ip', valor: 'IP65',
              nota: 'IP65: polvo y chorros de agua. Es lo que hay que pedir si el lector se va a caer al suelo.' },
            { et: 'En exterior o con líquidos', filtro: F + 'proteccion_ip', valor: 'IP67',
              nota: 'IP67: aguanta inmersión temporal.' }
          ]
        }
      ]
    },

    terminal: {
      titulo: 'Terminal o tablet',
      preguntas: [
        {
          id: 'so',
          pregunta: '¿Qué sistema operativo necesitas?',
          ayuda: 'Lo decide tu software, no la preferencia: pregunta a quien mantiene tu ERP antes de elegir.',
          opciones: [
            { et: 'Android', filtro: F + 'sistema_operativo', valor: 'Android',
              nota: 'Lo estándar hoy: casi todas las apps de almacén son Android.' },
            { et: 'Windows', filtro: F + 'sistema_operativo', valor: 'Windows',
              nota: 'Solo si tu ERP es un cliente pesado de escritorio.' }
          ]
        },
        {
          id: 'pantalla',
          pregunta: '¿Qué se hace en la pantalla?',
          ayuda: 'Cuanto más grande, más cómodo de usar y más incómodo de llevar encima.',
          opciones: [
            { et: 'Escanear y poco más', filtro: F + 'tamano_pantalla', valor: 'Hasta 4"',
              nota: 'Terminal compacto, cabe en una mano y en el bolsillo.' },
            { et: 'Escanear y consultar datos', filtro: F + 'tamano_pantalla', valor: '4" - 5"',
              nota: 'El tamaño más común: cómodo sin estorbar.' },
            { et: 'Rellenar formularios, ver documentos',
              filtro: F + 'tamano_pantalla', valor: '5" - 6"',
              nota: 'Pantalla grande, tipo móvil actual.' },
            { et: 'Firmar albaranes, ver planos', filtro: F + 'tamano_pantalla', valor: '8" o más',
              nota: 'Ya es una tablet: para vehículo, taller o reparto.' }
          ]
        },
        {
          id: 'red',
          pregunta: '¿El equipo sale del edificio?',
          ayuda: 'Pagar 4G o 5G para un equipo que no sale del almacén es tirar dinero.',
          opcional: true,
          opciones: [
            { et: 'No, se queda dentro', filtro: F + 'conectividad', valor: 'Wi-Fi',
              nota: 'Con Wi-Fi basta, y sale más barato.' },
            { et: 'Sí, reparto o servicio técnico',
              filtro: F + 'conectividad', valor: '4G',
              nota: 'Necesita datos móviles para trabajar fuera de cobertura Wi-Fi.' },
            { et: 'Sí, y quiero red móvil de última generación',
              filtro: F + 'conectividad', valor: '5G',
              nota: '5G: más caro, tiene sentido si el equipo va a durar años fuera.' }
          ]
        }
      ]
    },

    rfid: {
      titulo: 'Equipo RFID',
      preguntas: [
        {
          id: 'frecuencia',
          pregunta: '¿A qué distancia hay que leer?',
          ayuda: 'Antes de nada, una advertencia física: el metal y los líquidos degradan la señal UHF. En esos materiales hace falta un tag específico o la instalación no funcionará por mucho lector que se ponga.',
          opciones: [
            { et: 'A metros: inventario, portales, palés',
              filtro: F + 'frecuencia_rfid', valor: 'UHF',
              nota: 'UHF es lo habitual en logística. En Europa, banda 865-868 MHz: ojo al comprar equipo de importación.' },
            { et: 'Al contacto: tarjetas, control de acceso',
              filtro: F + 'frecuencia_rfid', valor: 'HF',
              nota: 'HF/NFC: alcance de centímetros, pero inmune a buena parte de los problemas del UHF.' }
          ]
        },
        {
          id: 'tipo',
          pregunta: '¿Qué tipo de equipo?',
          ayuda: 'De mano para buscar e inventariar; fijo para que lea solo cuando algo pasa por delante.',
          opciones: [
            { et: 'De mano, para inventariar y buscar', handle: 'rfid-lectores',
              nota: 'Lector RFID de mano o terminal con RFID integrado.' },
            { et: 'Fijo, para un portal o una línea', handle: 'lectores-fijos',
              nota: 'Con puertos de antena, montado en el paso.' },
            { et: 'Una impresora que grabe los tags', handle: 'impresoras-rfid',
              nota: 'Imprime la etiqueta y graba el chip en la misma pasada.' }
          ]
        }
      ]
    }
  };

  // ------------------------------------------------------------------
  // Estado
  // ------------------------------------------------------------------
  var familia = null;
  var paso = 0;
  var respuestas = [];   // {pregunta, etiqueta, filtro, valor, handle, nota}

  // Los datos generados están indexados por HANDLE de colección, no por
  // familia, porque algunas respuestas cambian de colección y hay que mirar
  // los filtros de la colección de DESTINO: aplicar allí un filtro que no
  // existe lleva a una lista vacía.
  function datosDe(handle) {
    return OPC[handle] || null;
  }

  function disponible(op) {
    if (!op.filtro) return true;
    var d = datosDe(handleActual());
    if (!d || !d.filtros) return true;   // sin datos, no se esconde nada
    var vals = d.filtros[op.filtro];
    return !!(vals && vals.indexOf(op.valor) !== -1);
  }

  function preguntasDe(f) {
    return (GUIONES[f] && GUIONES[f].preguntas) || [];
  }

  // Colección de partida de cada familia. Debe existir en OPCIONES_SELECTOR.
  var RAIZ = {
    impresora: 'impresoras-1',
    lector: 'lectores-de-codigos-de-barras',
    terminal: 'tablets-y-complementos',
    rfid: 'rfid'
  };

  function handleActual() {
    for (var i = respuestas.length - 1; i >= 0; i--) {
      if (respuestas[i].handle) return respuestas[i].handle;
    }
    return RAIZ[familia] || 'productos';
  }

  function urlResultado() {
    var handle = handleActual();
    var d = datosDe(handle);
    var partes = [];
    respuestas.forEach(function (r) {
      if (!r.filtro || !r.valor) return;
      // Solo se arrastra el filtro si la colección de destino lo ofrece con
      // ese valor. Al cambiar de colección (portátiles, RFID de mano...) hay
      // filtros que allí no existen, y aplicarlos daría una lista vacía.
      if (d && d.filtros) {
        var vals = d.filtros[r.filtro];
        if (!vals || vals.indexOf(r.valor) === -1) return;
      }
      partes.push(encodeURIComponent(r.filtro) + '=' + encodeURIComponent(r.valor));
    });
    var url = '/collections/' + handle;
    return partes.length ? url + '?' + partes.join('&') : url;
  }

  // ------------------------------------------------------------------
  // Pintado
  // ------------------------------------------------------------------
  function pintarPregunta() {
    els.resultado.hidden = true;
    els.opciones.innerHTML = '';

    var q = paso === 0 && !familia ? INICIO : preguntasDe(familia)[paso - 1];
    if (!q) return terminar();

    var total = familia ? preguntasDe(familia).length + 1 : 1;
    els.progreso.textContent = 'Paso ' + (paso + 1) + (familia ? ' de ' + total : '');
    els.pregunta.textContent = q.pregunta;
    els.ayuda.textContent = q.ayuda || '';
    els.ayuda.hidden = !q.ayuda;

    var opciones = q.opciones.filter(disponible);
    opciones.forEach(function (op) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'se-opcion';
      var t = document.createElement('strong');
      t.textContent = op.et;
      b.appendChild(t);
      if (op.nota) {
        var n = document.createElement('span');
        n.textContent = op.nota;
        b.appendChild(n);
      }
      b.addEventListener('click', function () { elegir(q, op); });
      els.opciones.appendChild(b);
    });

    if (q.opcional) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'se-saltar';
      s.textContent = 'Me da igual, sáltala';
      s.addEventListener('click', function () {
        respuestas.push({ pregunta: q.pregunta, etiqueta: 'sin preferencia' });
        paso++;
        pintarPregunta();
      });
      els.opciones.appendChild(s);
    }

    els.atras.hidden = paso === 0;
    els.reiniciar.hidden = paso === 0;
    pintarResumen();
  }

  function elegir(q, op) {
    if (op.familia) {
      familia = op.familia;
      respuestas = [{ pregunta: q.pregunta, etiqueta: op.et, nota: op.nota }];
      paso = 1;
      return pintarPregunta();
    }
    respuestas.push({
      pregunta: q.pregunta, etiqueta: op.et, filtro: op.filtro,
      valor: op.valor, handle: op.handle, nota: op.nota
    });
    paso++;
    if (paso > preguntasDe(familia).length) return terminar();
    pintarPregunta();
  }

  function pintarResumen() {
    els.resumen.innerHTML = '';
    respuestas.forEach(function (r, i) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'se-chip';
      chip.textContent = r.etiqueta;
      chip.title = 'Volver a esta pregunta';
      chip.addEventListener('click', function () {
        if (i === 0) return reiniciar();
        respuestas = respuestas.slice(0, i);
        paso = i;
        pintarPregunta();
      });
      els.resumen.appendChild(chip);
    });
    els.resumen.hidden = !respuestas.length;
  }

  function reiniciar() {
    familia = null;
    paso = 0;
    respuestas = [];
    pintarPregunta();
  }

  // ------------------------------------------------------------------
  // Resultado: se consulta la colección filtrada de verdad
  // ------------------------------------------------------------------
  function terminar() {
    els.opciones.innerHTML = '';
    els.pregunta.textContent = 'Esto es lo que encaja';
    els.ayuda.hidden = true;
    els.progreso.textContent = 'Resultado';
    els.atras.hidden = false;
    els.reiniciar.hidden = false;
    pintarResumen();

    els.resultado.hidden = false;
    els.resAviso.hidden = true;
    els.resProductos.innerHTML = '';
    els.resCuenta.textContent = 'Buscando en el catálogo…';
    els.resTitulo.textContent = (GUIONES[familia] || {}).titulo || 'Recomendación';

    var motivos = respuestas.filter(function (r) { return r.nota; })
      .map(function (r) { return r.nota; });
    els.resTexto.innerHTML = motivos.map(function (m) {
      return '<li>' + m + '</li>';
    }).join('');

    var url = urlResultado();
    els.resEnlace.href = url;

    // Se pide SOLO la sección de la parrilla, no la página entera: una
    // colección completa pesa unos 970 KB y esto se usa sobre todo desde el
    // móvil; el fragmento son 240 KB. Dentro van tanto el listado como el
    // recuento (`ProductCountDesktop`), comprobado en
    // `main-collection-product-grid.liquid`.
    //
    // Ojo: el valor de `section_id` es el TIPO de la sección
    // (`main-collection-product-grid`), NO su clave en `collection.json`
    // (`product-grid`). Con la clave responde 404. Comprobado contra la
    // tienda; con filtros y sin resultados también.
    var urlFragmento = url + (url.indexOf('?') === -1 ? '?' : '&') +
      'section_id=main-collection-product-grid';

    fetch(urlFragmento)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cnt = doc.getElementById('ProductCountDesktop');
        var n = cnt ? (cnt.textContent.match(/\d+/) || [null])[0] : null;

        var tarjetas = doc.querySelectorAll('#product-grid .card__heading a');
        if (!tarjetas.length) {
          els.resCuenta.textContent = 'Ninguna referencia cumple todo a la vez.';
          els.resAviso.hidden = false;
          return;
        }
        els.resCuenta.textContent = n
          ? n + (n === '1' ? ' referencia encaja' : ' referencias encajan')
          : 'Referencias que encajan';

        var imgs = doc.querySelectorAll('#product-grid .card__inner img');
        var precios = doc.querySelectorAll('#product-grid .price__regular .price-item--regular');
        for (var i = 0; i < Math.min(4, tarjetas.length); i++) {
          var a = tarjetas[i];
          var li = document.createElement('li');
          li.className = 'se-producto';

          var enlace = document.createElement('a');
          enlace.href = a.getAttribute('href').split('?')[0];

          if (imgs[i]) {
            var im = document.createElement('img');
            im.src = imgs[i].getAttribute('src') || '';
            im.alt = '';
            im.loading = 'lazy';
            enlace.appendChild(im);
          }
          var tx = document.createElement('span');
          tx.textContent = (a.textContent || '').trim();
          enlace.appendChild(tx);
          if (precios[i]) {
            var pr = document.createElement('em');
            pr.textContent = precios[i].textContent.trim();
            enlace.appendChild(pr);
          }
          li.appendChild(enlace);
          els.resProductos.appendChild(li);
        }
        els.resEnlace.textContent = n && parseInt(n, 10) > 4
          ? 'Ver las ' + n + ' referencias'
          : 'Ver el listado completo';
      })
      .catch(function () {
        // Si la consulta falla, se enseña el enlace igualmente: es mejor un
        // enlace que un error, y la colección filtrada funciona sola.
        els.resCuenta.textContent = 'Ver las referencias que encajan';
        els.resEnlace.textContent = 'Abrir el listado';
      });
  }

  els.atras.addEventListener('click', function () {
    if (paso <= 1) return reiniciar();
    respuestas.pop();
    paso--;
    pintarPregunta();
  });
  els.reiniciar.addEventListener('click', reiniciar);

  pintarPregunta();
})();
